import { validateCNPJ } from './cpf_cnpj';

export default {
    validate(value) {
        const onlyNumbers = value.replace(/[^\d]+/g, '');
        if (onlyNumbers.length !== 14) {
            return false;
        }
        return validateCNPJ(onlyNumbers);
    },
}